import { LeadList } from './LeadList';
import { LeadShow } from './LeadShow';
import { LeadEdit } from './LeadEdit';
import { LeadCreate } from './LeadCreate';
import { Lead } from '@/types';

export default {
    list: LeadList,
    show: LeadShow,
    edit: LeadEdit,
    create: LeadCreate,
    recordRepresentation: (record: Lead) =>
        record?.name?.trim() || `Lead #${record?.id ?? ''}`,
};
